import { Base } from '@studiometa/js-toolkit';
import MasonryLayout from 'masonry-layout';

/**
 * @typedef {{}} MasonryProps
 */

/**
 * Masonry Masonry.
 * @augments {Base<MasonryProps>}
 */
export default class Masonry extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Masonry',
  };

  /**
   * Mount masonry.
   */
  mounted() {
    this.msnry = new MasonryLayout(this.$el, {
      itemSelector: '.thumb',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true,
    });

    // Relayout once images have their real dimensions, otherwise items overlap
    // because their height is still 0 at mount time.
    this.relayout = () => this.msnry?.layout?.();
    this.images = Array.from(this.$el.querySelectorAll('img'));
    this.images.forEach((img) => {
      if (img.complete) {
        return;
      }
      img.addEventListener('load', this.relayout);
      img.addEventListener('error', this.relayout);
    });
  }

  /**
   * Clean up listeners and masonry instance.
   */
  destroyed() {
    this.images?.forEach((img) => {
      img.removeEventListener('load', this.relayout);
      img.removeEventListener('error', this.relayout);
    });
    this.msnry?.destroy?.();
  }
}
